<template>
  <footer class="footer px-4 mx-2">
    <div class="footer-border pb-5"></div>
    <b-row align-v="center" class="justify-content-lg-between">
      <b-col lg="6">
        <div class="copyright text-center text-lg-left text-muted">
          <!-- <router-link to="/definicoes" class="footer-link text-black">
            Definições
          </router-link> -->
        </div>
      </b-col>
      <b-col lg="6">
        <b-nav align="center" class="nav-footer justify-content-lg-end">
          <div class="px-3 text-black center-center">
            <img src="~@/assets/img/brand/logo_abitue.png" />
          </div>
          <div class="px-3 text-black center-center">© {{ year }}</div>
        </b-nav>
      </b-col>
    </b-row>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style>
.footer-link {
  font-family: Cygre;
  font-size: 26px;
  font-style: normal;
  line-height: 60px;
  color: black !important;
}
.footer-border {
  border-top: 1px solid black !important;
}
ul.nav.nav-footer.justify-content-lg-end.justify-content-center {
  align-items: center;
}
ul.nav.nav-footer.justify-content-lg-end.justify-content-center div {
  height: 50px;
}
.center-center {
  display: flex;
  align-items: center;
}
</style>
